<template>
  <div class="page_container">
    <div class="page_header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item ><span v-text="activeTab == 1 ? '用户信息' : activeTab == 2 ? '产品信息' : ''"></span></el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-card class="page_card" v-loading="loading">
<!--       <div class="user_name" v-text="personalForm.name"></div>-->

      <div class="tab_list">
        <ul>
          <li @click="handleClickTab(1)" :class="activeTab == 1 ? 'active' : ''">用户信息</li>
          <li @click="handleClickTab(2)"  :class="activeTab == 2 ? 'active' : ''">产品信息</li>
<!--          <li @click="handleClickTab(3)"  :class="activeTab == 3 ? 'active' : ''">操作记录</li>-->
        </ul>
        <div>
          <template v-if="activeTab == 2">
            <el-button size="mini" plain type="primary" @click="handleClickAddProduct">添加产品</el-button>
<!--            <el-button size="mini" type="primary" @click="handleClickBatchAddProduct">批量添加</el-button>-->
          </template>

        </div>
      </div>
      <template v-if="activeTab == 1">
        <div class="personal_box">
          <el-form :model="personalForm"  label-position="left" ref="personalForm" size="small">
            <ul>
              <li>
                <div class="title">基础信息</div>
                <el-form-item label="头像：" prop="head_img" class="align-items-center">
                  <div class="head_img">
                    <img :src="personalForm.avatar ? personalForm.avatar :'https://download.hecoos.com/enlightv/2024-33/dkd3HamkzAhsHzi3zARs.png'" alt="">
                  </div>
                </el-form-item>
                <el-form-item label="姓名：" prop="name">
                  <div v-text="personalForm.name"></div>
                </el-form-item>
<!--                <el-form-item label="密码" prop="username">-->
<!--                  <div>密码   <el-button type="text">重置密码</el-button></div>-->
<!--                </el-form-item>-->
                <el-form-item label="邮箱：" prop="email">
                  <div v-text="personalForm.email">姓名</div>
                </el-form-item>
                <el-form-item label="手机号：" prop="phone">
                  <div v-text="personalForm.phone">姓名</div>
                </el-form-item>
<!--                <el-form-item label="性别" prop="gender">-->
<!--                  <div>性别</div>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="年龄" prop="age">-->
<!--                  <div>年龄</div>-->
<!--                </el-form-item>-->

              </li>

<!--              <li>-->
<!--                <div class="title">其他个人信息</div>-->

<!--                <el-form-item label="个人地址" prop="attr">-->
<!--                  <div>个人地址</div>-->
<!--                </el-form-item>-->
<!--                <el-form-item label="职业" prop="profession">-->
<!--                  <div>职业</div>-->
<!--                </el-form-item>-->

<!--                <el-form-item label="教育背景" prop="age">-->
<!--                  <div>教育背景</div>-->
<!--                </el-form-item>-->

<!--              </li>-->


            </ul>
          </el-form>
        </div>
      </template>
      <template v-if="activeTab == 2">
<!--        <el-form size="small" @submit.native.prevent :inline="true">-->
<!--          <div class="">-->
<!--            <div>-->
<!--              <el-form-item label="">-->
<!--                <el-input v-model="searchForm.keyWords" placeholder="请输入需要查询的内容" @clear="handleClickSearch()" @keyup.enter.native="handleClickSearch"  clearable  suffix-icon="el-icon-search"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-button size="small"  @click="handleClickReset">重置</el-button>-->
<!--            </div>-->
<!--          </div>-->
<!--        </el-form>-->
        <el-table ref="table1" :data="tableData" style="width: 100%" :height="tableHeight">
          <el-table-column prop="id" align="center" label="编号" min-width="80"></el-table-column>
          <el-table-column prop="product_name" align="center" label="产品名称" min-width="140">
            <template slot-scope="{row}">
              <span class="template_color" @click="handleClickDetail(row)" v-if="row.product && row.product.product_name" v-text="row.product.product_name"></span>
            </template>
          </el-table-column>
          <el-table-column prop="name" align="center" label="购买人" min-width="120">
            <template slot-scope="{row}">
              <span v-if="row.user && row.user.name" v-text="row.user.name"></span>
            </template>
          </el-table-column>
          <el-table-column prop="order_num" align="center" label="所属订单编号" min-width="150">
            <template slot-scope="{row}">
              <span v-if="row.order && row.order.order_num" v-text="row.order.order_num"></span>
            </template>
          </el-table-column>
          <el-table-column prop="machine_id" align="center" label="当前状态" min-width="120">
            <template slot-scope="{row}">
              <span v-text="row.machine_id ? '已激活' : '未激活'"></span>
            </template>
          </el-table-column>
          <el-table-column   prop="start_date"  align="center"  label="有效期截至日"  min-width="320">
            <template slot-scope="{row}">
              <span v-if="row.order" v-text="row.order.start_date +' ~ '+ row.order.end_date"></span>
            </template>
          </el-table-column>
          <el-table-column prop="date" align="center" label="操作" width="60"  fixed="right">
            <template slot-scope="{row}">
<!--              <el-button v-if="!row.license_code" size="mini" type="text" @click="handleClickGenerateAuthCode(row)">生成激活码</el-button>-->
<!--              <span v-if="!row.license_code" class="el-table-column-line"></span>-->
<!--              <el-button v-if="row.license_code" size="mini" type="text" @click="handleClickRetrieveAuthCode(row)">回收激活码</el-button>-->
<!--              <span v-if="row.license_code"  class="el-table-column-line"></span>-->
<!--              <el-button size="mini" @click="handleClickDetail(row)"  type="text">详情</el-button>-->
<!--              <el-button size="mini" @click="handleClickLog(row)"  type="text">操作记录</el-button>-->
<!--              <span class="el-table-column-line"></span>-->
<!--              <el-button size="mini"  type="text" @click="handleClickCancel(row)">作废</el-button>-->


              <el-dropdown trigger="click" class="dropdown_more" >
                <i class="el-icon-more"></i>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleClickDetail(row)" >详情</el-dropdown-item>
                  <el-dropdown-item @click.native="handleClickLog(row)" >操作记录</el-dropdown-item>
                  <el-dropdown-item v-if="row.license_code" @click.native="handleClickRetrieveAuthCode(row)" >回收激活码</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>


        </el-table>
        <el-pagination background
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="pagination.pageNum"
                       :page-sizes="pagination.pageSizes"
                       :page-size="pagination.pageSize"
                       :layout="pagination.layout"
                       :total="pagination.total">
        </el-pagination>
      </template>

    </el-card>


<!--    <productAdd :productAddVisible.sync="productAddVisible" v-if="productAddVisible" :uid="uid" :companyId="company_id" @success="handleSizeChange()"/>-->
<!--    <productBatchAdd :productBatchAddVisible.sync="productBatchAddVisible" v-if="productBatchAddVisible"  @success="handleSizeChange()"/>-->

<!--    <generateAuthCode :generateAuthCodeVisible.sync="generateAuthCodeVisible" v-if="generateAuthCodeVisible" :licenseId="licenseId" :productName="productName"  @success="generateAuthCodeSuccess"/>-->
<!--    <copyAuthCode :copyAuthCodeVisible.sync="copyAuthCodeVisible" v-if="copyAuthCodeVisible" :licenseCode="licenseCode" :productName="productName"  @success="handleClickSearch"/>-->
<!--    <retrieveAuthCode :retrieveAuthCodeVisible.sync="retrieveAuthCodeVisible" v-if="retrieveAuthCodeVisible" :retrieveInfo="retrieveInfo"   @success="handleClickSearch"/>-->

<!--    <productDetail :productDetailVisible.sync="productDetailVisible" v-if="productDetailVisible" :productId="productId" />-->
<!--    <productLog :logVisible.sync="logVisible" v-if="logVisible" :productName="productName" :logId="logId"  />-->
  </div>
</template>

<script>
import { adminUserDetail,adminUserProductList } from '@/api/api'
import {getTableHeight} from '@/utils'
import {pagination} from '@/mixins'
import {mapState} from "vuex";
// import productAdd from "./product_add";
// import productBatchAdd from "./product_batch_add";
// import generateAuthCode from './generate_auth_code.vue'
// import copyAuthCode from './copy_auth_code.vue'
// import retrieveAuthCode from './retrieve_auth_code.vue'
// import productDetail from './product_detail.vue'
// import productLog from './product_log.vue'


export default {
  name: 'enterprise_detail',
  components: {
    // productAdd,
    // productBatchAdd,
    // generateAuthCode,
    // copyAuthCode,
    // retrieveAuthCode,
    // productDetail,
    // productLog
  },
  data() {
    return {
      loading:false,
      activeTab:1,
      personalForm:{ },
      tableData:[],
      tableHeight:'',
      productAddVisible:false,
      productBatchAddVisible:false,
      uid:'',
      company_id:'',
      searchForm:{
        keyWords:''
      },
      generateAuthCodeVisible:false,
      licenseId:0,
      productName:'',
      copyAuthCodeVisible:false,
      licenseCode:'',
      retrieveAuthCodeVisible:false,
      retrieveInfo:{},

      productDetailVisible:false,
      productId:0,
      logVisible:false,
      logId:0
    }
  },

  mixins: [pagination],
  created() {
    if(this.$route.query.uid){
      this.uid = this.$route.query.uid
    }
    if(this.$route.query.company_id){
      this.company_id = this.$route.query.company_id
    }
    //将计算的table高度赋值给table
    this.tableHeight = getTableHeight(260)
  },
  mounted() {
    const adminActiveTab = localStorage.getItem('adminActiveTab');

    if(adminActiveTab){
      this.activeTab = adminActiveTab
      if(adminActiveTab == 1){
        this.getAdminUserDetail()
      }else{
        this.handleClickSearch()
      }
    }

    //窗口缩放时动态修改table的高度
    window.onresize = () => {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer)
      }
      //开启定时器，节流函数
      this.resizeTimer = setTimeout(() => {
        //将计算的table高度赋值给table
        this.tableHeight = getTableHeight(260)
        //清除定时器
        this.resizeTimer = null
      }, 100)
    }
  },
  computed: {
    ...mapState(['adminUserInfo']),
  },
  methods: {
    // 操作记录
    handleClickLog(row){
      this.productName = row.product ? row.product.product_name : ''
      this.logId = row.id
      this.logVisible = true
    },
    handleClickDetail(row){
      this.productId = row.id
      this.productDetailVisible = true
    },
    // 搜索
    handleClickSearch(){
      this.pagination.pageNum = 1
      this.getTableData()
    },
    // 重置
    handleClickReset(){
      this.searchForm.keyWords = ''
      this.pagination.pageNum = 1
      this.getTableData()
    },
    // 获取用户信息
    getAdminUserDetail(){
      this.loading = true
      let postData = {
        uid:this.uid,
      }
      adminUserDetail(postData).then(res => {
        if (res.code === 200) {
          let {data} = res
          this.personalForm = data
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    // 生成激活码
    handleClickGenerateAuthCode(row){
      this.licenseId = row.id
      this.productName = row.product_name
      this.generateAuthCodeVisible = true
    },
    // 生成激活码之后的回调
    generateAuthCodeSuccess(data){
      this.productName = data.product_name
      this.licenseCode = data.license_code
      this.copyAuthCodeVisible = true
    },
    // 回收激活码
    handleClickRetrieveAuthCode(row){
      this.retrieveInfo = {
        license_id:row.id,
        license_code:row.license_code,
        product_name:row.product_name,
        end_date:row.end_date,
        status_text:row.machine_id ? '已激活' : '未激活'
      }
      this.retrieveAuthCodeVisible = true
    },
    handleClickTab(value){
      this.activeTab = value
      localStorage.setItem('adminActiveTab', value);
      if(value == 2){
        this.pagination.pageNum = 1
        this.getTableData()
      }else{
        this.getAdminUserDetail()
      }
    },
    // 添加产品
    handleClickAddProduct(){
      this.productAddVisible = true
    },
    // 批量添加产品
    handleClickBatchAddProduct(){
      this.productBatchAddVisible = true
    },
    // 获取数据
    getTableData() {
      this.loading = true
      let postData = {
        uid:this.uid,
        page: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        keyWords:this.searchForm.keyWords
      }
      adminUserProductList(postData).then(res => {
        if (res.code === 200) {
          let {total, data} = res.data
          this.tableData = data
          this.pagination.total = total
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pagination.pageNum = 1
      this.pagination.pageSize = val
      this.getTableData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.getTableData()
    },


  },
  watch: {

  },
}
</script>

<style scoped lang="scss">
.el-form-item.align-items-center{
  display: flex;
  align-items: center;
}
.dropdown_more{
  cursor: pointer;
}

.el-icon-more{
  transform: rotate(90deg);
  cursor: pointer;
  vertical-align: middle;
}
.el-icon-more:hover{
  color: #1990ff;
}
.kx {
  width: 100%;
  height: 30px;
}
.chart{
  height:540px
}
.page_container .page_card {
  overflow-y: scroll;
  padding-bottom: 20px;
  .user_name{
    line-height: 30px;
    margin-bottom: 10px;
    font-size: 16px;
    font-weight: bold;
  }

  .tab_list{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    ul{
      display: flex;
      li{
        height: 34px;
        line-height: 22px;
        margin-right: 24px;
        color: rgba(102, 102, 102, 1);
        font-size: 16px;
        border-bottom: 1px solid #fff;
        box-sizing: border-box;
        cursor: pointer;
        &.active{
          color: rgba(25, 144, 255, 1);
          border-bottom: 1px solid rgba(25, 144, 255, 1);
        }
      }
    }
  }


  .personal_box{
    width: 100%;
    ul{
      width: 100%;
      li{
        width: 100%;
        margin-bottom: 24px;
        background: #fff;
        border-radius: 8px;
        padding: 24px 20px 6px;
        box-sizing: border-box;
        .title{
          width: 100%;
          line-height: 24px;
          color: rgba(51, 51, 51, 1);
          font-size: 14px;
          font-weight: bold;
          margin-bottom: 16px;
        }
        .head_img{
          //width: 64px;
          position: relative;
          border-radius: 50%;

          div.hover_box{
            display: none;
          }
          img{
            display: block;
            width: 64px;
            height: 64px;
            object-fit: cover;
            border-radius: 50%;
            border: 1px solid #ccc;
            box-sizing: border-box;
          }
        }
        ::v-deep .el-form-item__label{

        }

      }
    }
  }
}


</style>
